// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTrendingDown as RawLucideTrendingDown } from "lucide-react";
export const LucideTrendingDown = /* @__PURE__ */ createIcon(RawLucideTrendingDown, "LucideTrendingDown", 2);
